require("packs/link_tracker")

// Loop through all showMoreLessButtons
document.querySelectorAll(".showMoreLessButtons").forEach((button) => {
  // Get the container and items related to the button
  let itemsContainer = document.getElementById(
    `itemsContainer${button.dataset.index}`
  );
  let items = itemsContainer.querySelectorAll(".item");

  // Toggle visibility of items when the button is clicked
  button.addEventListener("click", () => {
    let isExpanded = button.dataset.expanded === "true"; // Check if the button is currently expanded

    // Toggle visibility of items starting from the 7th item
    items.forEach((item, index) => {
      if (index >= 7) {
        item.classList.toggle("hidden", !isExpanded); // Toggle visibility based on the expanded state
      }
    });

    // Change button text and update its expanded state
    moreLess(isExpanded ? 'less' : 'more', button);
    button.dataset.expanded = !isExpanded; // Toggle expanded state

    // Toggle visibility of plus and minus icons
    let plusIcon = button.querySelector(".plusIcon");
    let minusIcon = button.querySelector(".minusIcon");
    plusIcon.classList.toggle("hidden", isExpanded);
    minusIcon.classList.toggle("hidden", !isExpanded);
  });

  // Set initial state of the button and items
  let initialExpandedState = items.length <= 7; // Check if total items <= 7
  if (!initialExpandedState) {
    // If there are more than 7 items
    items.forEach((item, index) => {
      if (index >= 7) {
        item.classList.add("hidden"); // Hide items starting from the 7th item
      }
    });
    moreLess('more', button) // Change button text to "Менее"
    button.dataset.expanded = "true"; // Set expanded state to true
  }

});

function moreLess(flag, btn) {
  let viewMore = btn.querySelector(".view-more");
  let viewLess = btn.querySelector(".view-less");
  if (flag === 'more') {
    viewMore.classList.remove('hidden');
    viewLess.classList.add('hidden');
  } else if (flag === 'less') {
    viewMore.classList.add('hidden');
    viewLess.classList.remove('hidden');
  }
}